import React from 'react';
import { useAuthUser } from 'react-auth-kit';
import User from '../Models/User';
import { Divider } from '@tremor/react';

const Fotter = () => {
    
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    return (
        <footer>
            <center>
                <label style={{color: "rgb(25, 7, 143)", fontWeight: 'bold', width: "100%", borderBottom: "2px rgba(161, 10, 164, 0.186) solid"}}>{user != null ? "Utilisateur : "+user?.Name+" / Abonné : "+user?.CodeAbonne+" / Filiale : "+user?.CodeFiliale+" / Service : "+user?.CodeS +" / Role : "+user?.Group : ""}</label>
                <br />
                <label htmlFor="" style={{color: "rgba(0, 0, 0, .5)"}}>eBCall © 2024 all rights reserved / Provide By IBG-Alpha Technology</label>
            </center>
        </footer>
    );
};

export default Fotter;